import { useEffect, useState } from "react";
import { CalendarDays, Clock, MapPin, BookOpen, User } from "lucide-react";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}

export default function Manasik() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/manasik`).then(({ data }) => setEvents(data)).catch(() => setEvents([]));
  }, []);

  return (
    <div data-testid="manasik-page">
      <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] px-4 py-16 text-center sm:px-6">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Jadwal Manasik</h1>
        <p className="mt-3 text-white/80">Ikuti rangkaian pembinaan teori dan praktik sebelum keberangkatan.</p>
      </section>

      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
        {events === null ? (
          <LoadingScreen />
        ) : events.length === 0 ? (
          <EmptyState title="Belum ada jadwal manasik" description="Jadwal manasik terbaru akan segera diinformasikan." />
        ) : (
          <div className="space-y-5">
            {events.map((e) => (
              <div key={e.id} data-testid={`manasik-item-${e.id}`} className="rounded-2xl bg-white p-6 shadow-[0_2px_16px_rgba(15,107,79,0.06)]">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <h3 className="font-heading text-lg font-semibold text-[#1F2937]">{e.title}</h3>
                  <StatusBadge status={e.status} />
                </div>
                <div className="mt-4 grid grid-cols-1 gap-2 text-sm text-[#64748B] sm:grid-cols-2">
                  <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4" /> {formatDate(e.date)}</p>
                  <p className="flex items-center gap-2"><Clock className="h-4 w-4" /> {e.time}</p>
                  <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {e.location}</p>
                  {e.guide_name && <p className="flex items-center gap-2"><User className="h-4 w-4" /> {e.guide_name}</p>}
                </div>
                <p className="mt-3 flex items-start gap-2 text-sm text-[#1F2937]"><BookOpen className="mt-0.5 h-4 w-4 shrink-0 text-[#0F6B4F]" /> {e.material}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
